const DAYS = [
  {
    day: 'Day One',
    date: 'Saturday, 14 November',
    events: [
      { time: '09:00', title: 'Doors open & chai', detail: 'Check in, grab swag, meet your fellow builders.' },
      { time: '10:00', title: 'Opening ceremony', detail: 'Welcome, keynote, and why open money matters.' },
      { time: '11:00', title: 'Bitcoin & Nostr 101', detail: 'Beginner workshops — wallets, keys, zaps, relays.' },
      { time: '13:00', title: 'Lunch & team formation', detail: 'Find your people. Teams of 2–4 form over food.' },
      { time: '14:00', title: 'Hacking begins', detail: 'Mentors on the floor. Build, build, build.' },
      { time: '19:00', title: 'Dinner & lightning talks', detail: 'Short talks from Kenyan women in Bitcoin.' },
    ],
  },
  {
    day: 'Day Two',
    date: 'Sunday, 15 November',
    events: [
      { time: '09:00', title: 'Breakfast & stand-up', detail: 'Coffee, mandazi, and a quick team check-in.' },
      { time: '10:00', title: 'Mentor office hours', detail: 'One-on-one help with code, design, and pitch.' },
      { time: '13:00', title: 'Lunch & final push', detail: 'Last sprint — polish those demos.' },
      { time: '15:30', title: 'Demo time', detail: 'Every team presents. Five minutes each, live demos.' },
      { time: '17:30', title: 'Prizes & closing', detail: 'Winners announced, sats distributed, group photo.' },
      { time: '18:30', title: 'Sundowner', detail: 'Celebrate as the sun sets over the city.' },
    ],
  },
];

export function Schedule() {
  return (
    <section id="schedule" className="scroll-mt-20 py-20 sm:py-28">
      <div className="container space-y-12">
        <div className="mx-auto max-w-2xl space-y-4 text-center">
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-primary">
            The Weekend
          </p>
          <h2 className="font-display text-4xl font-semibold tracking-tight text-balance sm:text-5xl">
            Two days, one unforgettable build
          </h2>
          <p className="text-lg leading-relaxed text-muted-foreground">
            Meals, coffee, and good company included — just bring a laptop and your curiosity.
          </p>
        </div>

        <div className="grid gap-10 lg:grid-cols-2 lg:gap-12">
          {DAYS.map((day) => (
            <div key={day.day} className="space-y-6">
              <div className="flex items-baseline justify-between border-b-2 border-primary pb-3">
                <h3 className="font-display text-2xl font-semibold">{day.day}</h3>
                <p className="text-sm font-medium text-muted-foreground">{day.date}</p>
              </div>
              <ol className="relative space-y-6 border-l border-border pl-6">
                {day.events.map((event) => (
                  <li key={event.time} className="relative">
                    <span
                      className="absolute -left-[31px] top-1 size-3.5 rounded-full border-2 border-primary bg-background"
                      aria-hidden
                    />
                    <div className="flex flex-wrap items-baseline gap-x-3">
                      <time className="font-mono text-sm font-semibold text-primary">
                        {event.time}
                      </time>
                      <h4 className="text-base font-semibold">{event.title}</h4>
                    </div>
                    <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                      {event.detail}
                    </p>
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
